import { AddProduct } from '../../pages';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useFileUpload } from 'use-file-upload';
import * as yup from 'yup';
import { InventoryController, WalletController } from '../../controllers';
import constant from '../../utils/constant';
import { MimaToastUtil } from '../../components';
import { appStore, userStore } from '../../stores';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const AddProductContainer = ({ closeModal, setShowSurvey }) => {
	const [loading, setLoading] = useState(false);
	const [fileOne, selectOneFile] = useFileUpload();
	const [fileTwo, selectTwoFile] = useFileUpload();
	const [fileThree, selectThreeFile] = useFileUpload();
	const [accountName, setAccountName] = useState('');
	const [displayInfo, setDisplayInfo] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.STOCKADDPRODUCTTYPE);

	const onSelect = async (values) => {
		const amount = values.sellingPriceUSD;
		await InventoryController.getRates('USD', amount);
	};

	const selectOneClick = () => {
		selectOneFile({ accept: 'image/*' });
	};
	const selectTwoClick = () => {
		selectTwoFile({ accept: 'image/*' });
	};
	const selectThreeClick = () => {
		selectThreeFile({ accept: 'image/*' });
	};

	const validationSchema = () => {
		return yup.object({
			name: yup.string().max(50, 'Item name cannot be more than 50 characters').required('name is required'),
			description: yup.string().max(100, 'Item description cannot be more than 100 characters'),
			type: yup.string().required('type is required'),
			unitOfMeasurement: yup.string().required('Unit Of Measurement is required'),
			noVariation: yup.boolean(),
			currencyCode: yup
				.string()
				.when('noVariation', {
					is: true,
					then: yup.string().required('Currency is required'),
					otherwise: yup.string(),
				}),
			quantity: yup
				.number()
				.when(['noVariation', 'type'], {
					is: (noVariation, type) => noVariation && type === 'Product',
					then: yup.number().min(1, "Quantity cannot be less than 1").required('Quantity is required'),
					otherwise: yup.number(),
				}),
			sellingPrice: yup
				.number()
				.when('noVariation', {
					is: true,
					then: yup.number().min(1, "Selling price cannot be less than 1").required('Selling Price is required'),
					otherwise: yup.number(),
				}),
			lowStockCount: yup.number(),
			hasSplit: yup.boolean(),
			splitType: yup
				.string()
				.when('hasSplit', {
					is: true,
					then: yup.string().required('Split type is required'),
					otherwise: yup.string(),
				}),
			splitName: yup
				.string()
				.when('hasSplit', {
					is: true,
					then: yup.string().required('Add Name of whom to split with'),
					otherwise: yup.string(),
				}),
			// splitEmail: yup
			// 	.string().email()
			// 	.when('hasSplit', {
			// 		is: true,
			// 		then: yup.string().email().required('Email of who you are splitting with is required'),
			// 		otherwise: yup.string().email(),
			// 	}),
			bankCode: yup
				.string()
				.when('hasSplit', {
					is: true,
					then: yup.string().required('Please select a bank'),
					otherwise: yup.string(),
				}),
			accountNumber: yup
				.string()
				.when('hasSplit', {
					is: true,
					then: yup.string().required('Please add Account number'),
					otherwise: yup.string(),
				}),
			// splitPaymentTrigger: yup
			// 	.string()
			// 	.when('hasSplit', {
			// 		is: true,
			// 		then: yup.string().required('Please select when to pay split payment'),
			// 		otherwise: yup.string(),
			// 	}),
		});
	};
	const verifyAccountNumber = async payload => {
		if (
			payload.beneficiaryBank &&
			payload.accountNumber &&
			payload.accountNumber.length === 10
		) {
			const { status, data, errorMessage } =
				await WalletController.verifyAccountNumber(payload);
			if (status === constant.Success) {
				return data.accountName;
			} else {
				MimaToastUtil.error({
					message: errorMessage,
				});
			}
		}
		return '';
	};

	const fileReader = async (file, field, values) => {
		if (file && typeof file.source === 'string') {
			const fileToSend = await fetch(file.source)
				.then(response => response.blob())
				.then(
					blob =>
						new File([blob], 'name', {
							type: blob.type,
							lastModified: new Date(),
						})
				);
			values[field] = fileToSend;
		}
	}
	const onSubmit = async payload => {
		setLoading(true);
		const fdata = new FormData();
		payload.accountName = accountName;

		delete payload.split;
		delete payload.hasImages;

		if (fileOne && fileOne.source) await fileReader(fileOne, 'imageOne', payload);
		if (fileTwo && fileTwo.source) await fileReader(fileTwo, 'imageTwo', payload);
		if (fileThree && fileThree.source) await fileReader(fileThree, 'imageThree', payload);

		delete payload.hasMulticurrency;

		for (const key in payload) {
			if (payload[key] === '') {
				delete payload[key];
			} else {
				fdata.append(key, payload[key]);
			}
		}

		const { status, errorMessage } = await InventoryController.createProduct(fdata);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: payload.noVariation ? constant.Success : constant.Success + ", Kindly Add a Variation",
			});
			closeModal();
			if (needFeedback._id) {
				setShowSurvey(true)
				userStore.setReviewId(needFeedback._id)
			}
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<AddProduct
			closeModal={closeModal}
			loading={loading}
			selectOneClick={selectOneClick}
			selectTwoClick={selectTwoClick}
			selectThreeClick={selectThreeClick}
			fileOne={fileOne}
			fileTwo={fileTwo}
			fileThree={fileThree}
			validationSchema={validationSchema}
			accountName={accountName}
			setAccountName={setAccountName}
			setLoading={setLoading}
			verifyAccountNumber={verifyAccountNumber}
			banks={appStore.banks.map(bank => {
				return { id: bank.key, value: bank.value };
			})}
			onSubmit={onSubmit}
			onSelect={onSelect}
			displayInfo={displayInfo}
			setDisplayInfo={setDisplayInfo}
		/>
	);
};

export default observer(AddProductContainer);
